/**
 * Global application constants
 */
export const APPLICATION_NAME = "Single Skill Database";

export const API_STALE_TIME = {
	THIRTY_SECONDS: 30000,
	ZERO_SECONDS: 0,
};

export const API_CACHE_TIME = {
	ZERO_SECONDS: 0,
};

export const MAX_FILE_SIZE_MB = 1 * 1024 * 1024;

export const ALLOWED_FILES = ".pdf, .csv, .doc, .docx, .jpg, .jpeg, .png";

export const MAX_FILE_SIZE_TITLE = "1MB";

export const MAX_PAGES_TO_SHOW_FOR_PAGINATION = 5;

export const LANGUAGES_KEYS = {
	en: "en",
	ur: "ur",
};

export const LANGUAGES_VALUES = {
	en: "🇺🇸 English",
	ur: "🇵🇰 اردو",
};

export const LANGUAGES = {
	english: "English",
	urdu: "Urdu",
};

export const EXPORT_OPTIONS = [
	{ value: "csv", label: "CSV" },
	{ value: "pdf", label: "PDF" },
	{ value: "excel", label: "Excel" },
];

// Dashboard constants
export const DASHBOARD_CARD_TYPES = {
	TOTAL_INSTITUTES: "totalInstitutes",
	TOTAL_STUDENTS: "totalStudents",
	RESULTS_ANNOUNCED: "resultsAnnounced",
} as const;

export const DASHBOARD_CARD_COLORS = {
	TOTAL_INSTITUTES: "#FF6B35", // Orange
	TOTAL_STUDENTS: "#4A90E2", // Blue
	RESULTS_ANNOUNCED: "#00BCD4", // Teal/Cyan
} as const;

export const DASHBOARD_MOCK_DELAY = 1000; // 1 second delay for mock API

// Exam constants
export const EXAM_TYPES = {
	FINAL: "Final",
	MID_TERM: "Mid Term",
} as const;

export const EXAM_STATUS = {
	PUBLISHED: "Published",
	UNPUBLISHED: "Unpublished",
} as const;

export const EXAM_STATUS_COLORS = {
	PUBLISHED: {
		bg: "bg-green-50",
		text: "text-green-700",
		border: "border-green-200",
	},
	UNPUBLISHED: {
		bg: "bg-orange-50",
		text: "text-orange-700",
		border: "border-orange-200",
	},
} as const;

export const ITEMS_PER_PAGE = 10;

/**
 * Chairman users see the dashboard only (sidebar + routes). Everyone else uses the full sidebar as admin.
 *
 * When the login API returns `roles` containing {@link CHAIRMAN_ROLE_SLUG}, that takes precedence.
 * Use {@link CHAIRMAN_EMAIL_ALLOWLIST} for accounts that should behave as chairman before the API sends `roles`.
 */
export const CHAIRMAN_ROLE_SLUG = "chairman" as const;

/** Emails treated as chairman until the API includes chairman in `roles` (compared case-insensitively). */
export const CHAIRMAN_EMAIL_ALLOWLIST: readonly string[] = ["chairman.pbte@gmail.com"];

// Results Processing constants
export const RESULTS_PER_PAGE = 5;
